import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const BarChart = (props) => {

    const { width, height, data, labels, className, datasetLabel } = props;

    const graphicData = {
        defaultFontFamily: "Poppins",
        labels: labels,
        datasets: [
            {
                label: datasetLabel,
                data: data,
                borderWidth: "0",
                barThickness: 40
            },
        ],
    };

    const options = {
        plugins: {
            // legend: false é sintaxe inválida no Chart.js v4 — deve ser objeto
            legend: { display: false },
        },
        scales: {
            y:
            {
                ticks: {
                    beginAtZero: true,
                },
            },
            x:
            {
                // Change here
                barPercentage: 0.5,
            },
        },
    };

    return (
        <Bar data={graphicData} height={height} width={width} options={options} className={className} />
    );
}

export default BarChart;